import { render, staticRenderFns } from "./ChannelsPromoBlocks.vue?vue&type=template&id=95632a44&scoped=true"
import script from "./ChannelsPromoBlocks.vue?vue&type=script&lang=js"
export * from "./ChannelsPromoBlocks.vue?vue&type=script&lang=js"
import style0 from "./ChannelsPromoBlocks.vue?vue&type=style&index=0&id=95632a44&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95632a44",
  null
  
)

export default component.exports